import React from "react";
import mq1 from "../../Assets/Images/landing/mq-new-1.jpg";
import mq2 from "../../Assets/Images/landing/mq-new-2.jpg";
import mq3 from "../../Assets/Images/landing/mq-new-3.jpg";
import mq4 from "../../Assets/Images/landing/mq-new-4.jpg";
import mq5 from "../../Assets/Images/landing/mq-new-5.jpg";
import mq6 from "../../Assets/Images/landing/mq-new-6.jpg";
import mq7 from "../../Assets/Images/landing/mq-new-7.jpg";
import mq8 from "../../Assets/Images/landing/mq-new-8.jpg";
import logoMark from "../../Assets/Images/landing/eww-logo.png";

type WatermarkKind =
  | "pill"
  | "diagonal"
  | "signature"
  | "center"
  | "logo"
  | "topbar"
  | "cornerText"
  | "frame";

// Curated pairing of photo + a distinct watermark style per card, mirroring the reference
// build 1:1 (desert dunes -> coral pill, strawberries -> diagonal repeat, etc).
const cards: { src: string; wm: WatermarkKind }[] = [
  { src: mq1, wm: "pill" },
  { src: mq2, wm: "diagonal" },
  { src: mq3, wm: "signature" },
  { src: mq4, wm: "center" },
  { src: mq5, wm: "logo" },
  { src: mq6, wm: "topbar" },
  { src: mq7, wm: "cornerText" },
  { src: mq8, wm: "frame" },
];

const WatermarkVariant: React.FC<{ kind: WatermarkKind }> = ({ kind }) => {
  switch (kind) {
    case "pill":
      return <div className="lr-marquee__wm lr-marquee__wm--pill">© eZy</div>;
    case "diagonal":
      return (
        <div className="lr-marquee__wm lr-marquee__wm--diagonal">
          <div>
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i}>© eZy WATERMARK · © eZy WATERMARK · © eZy WATERMARK ·</div>
            ))}
          </div>
        </div>
      );
    case "signature":
      return (
        <svg className="lr-marquee__wm lr-marquee__wm--signature" viewBox="0 0 155 70" fill="none">
          <path
            pathLength="100"
            d="M8 50C10 30 16 15 22 15C28 15 30 32 26 38C24 41 20 39 21 34C23 26 30 16 36 19C40 21 38 34 33 50M46 50L46 16C52 12 64 13 65 19C66 25 55 27 50 24C55 30 65 40 74 50C84 60 96 68 108 60C116 55 122 62 130 56"
            stroke="#fff"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "center":
      return (
        <div className="lr-marquee__wm lr-marquee__wm--center">
          eZy<span>.</span>
        </div>
      );
    case "logo":
      return (
        <div className="lr-marquee__wm lr-marquee__wm--logo">
          <img src={logoMark} alt="" />
        </div>
      );
    case "topbar":
      return (
        <div className="lr-marquee__wm lr-marquee__wm--topbar">
          <span>© eZy Watermark</span>
          <span>2026</span>
        </div>
      );
    case "cornerText":
      return (
        <div className="lr-marquee__wm lr-marquee__wm--corner-text">
          eZy<span>/2026</span>
        </div>
      );
    case "frame":
      return (
        <>
          <div className="lr-marquee__wm lr-marquee__wm--frame-border" />
          <div className="lr-marquee__wm lr-marquee__wm--frame-label">© eZy · SIGNED</div>
        </>
      );
  }
};

const Marquee: React.FC = () => {
  const row = [...cards, ...cards];
  return (
    <section className="lr-marquee">
      <p className="lr-marquee__label">One tap · Every watermark style</p>
      <div className="lr-marquee__track">
        <div className="lr-marquee__row">
          {row.map((p, i) => (
            <div key={i} className="lr-marquee__item">
              <img src={p.src} alt="" loading="lazy" />
              <WatermarkVariant kind={p.wm} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Marquee;
